import store from "@/store"

const getLayout = (to) => {
  switch (to.meta.layout) {
  case "Simple":
      return "Simple"
  case "Base":
      return "Base"
  default:
      return "Base"
  }
}

export default (to) => {
  store.commit("setLayout", getLayout(to))
}